import React from 'react'
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core'
import { useUserInfoStyles } from './DataDisplay.styles'
import Lightbox from 'react-image-lightbox'
const UserInfo = ({ avatar, fullName = '', phone = '' }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const classes = useUserInfoStyles()

  const handleOpen = () => {
    if (avatar) setIsOpen(prevState => !prevState)
  }

  return (
    <ListItem
      alignItems="flex-start"
      disableGutters
      classes={{
        root: classes.root
      }}
    >
      <ListItemAvatar>
        <Avatar
          alt={'user_avatar_' + fullName}
          src={avatar}
          onClick={handleOpen}
        />
        {isOpen && <Lightbox mainSrc={avatar} onCloseRequest={handleOpen} />}
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant="body2" className={classes.primaryTypography}>
            {fullName || ''}
          </Typography>
        }
        secondary={
          <Typography component="span" variant="body2" color="textSecondary">
            {phone?.toPhone() || ''}
          </Typography>
        }
      />
    </ListItem>
  )
}
export default UserInfo
